
import { Button, Grid, TextField, Typography } from '@material-ui/core';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import EditIcon from '@material-ui/icons/Edit';
import Data from '../../classes/Data';
import Table from '../Table/Table';
import { AppContext } from '../../context/context';
import { SaveAlt, ArrowBack } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import { CampaignData, CampaignProps, CampaignUpdatePayloadState, CustomData } from '../../Interfaces/Interfaces';

const Campaign = (props: CampaignProps) => {
	//const [state, setState] = useState<>()
    /*isLogged, modalPayload */
    const { sharedData: { isLogged,modalPayload },setSharedData } = useContext(AppContext);
    const location = useLocation()
    const locationPathname = location.pathname
    const campaignId = locationPathname.split('/')[2];
    const history = useHistory();
    const columns = props.headers;
    const [data, setData] = useState<Required<CampaignData>|null>(null)
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [updatePayload, setUpdatePayload] = useState<CampaignUpdatePayloadState>({
        name: "",
        description:""
    });
    //const dataObject = new Data(`CampaignDetails/${campaignId}`);
    const dataObject = useMemo<CustomData>(() => {
        return { campaign: new Data(`CampaignDetails/${campaignId}`), campaigns: new Data(`Campaigns/${campaignId}`) };
    }, [campaignId])

    //{
    //    id: campaignId,
    //        name: data?.name,
    //            description: data?.description,
    //                imageUrl: "string",
    //                    createdDate: data?.createdDate
    //}

    useEffect(() => {
        if (data) {
            setUpdatePayload({
                name: data.name,
                description: data.description
            })
        }
    }, [data])

    useEffect(() => {
        dataObject.campaign.GET(setData);
    }, [campaignId, dataObject])

    //console.log(data)

    const actionHandler = (id: number | string): void => {
        return history.push(`/Mission/${id}/Summary`, [locationPathname.split('/')[1].toLocaleLowerCase(),campaignId])
    }

    const saveHandler = () => {
  //      if (Object.entries(updatePayload).find((field: any): boolean => {
  //          console.log(field)
  //          return false    
  //      })) {
  //          console.log("in")
		//}
        if (updatePayload.name.trim() !== data?.name.trim() ||
            updatePayload.description.trim() !== data.description.trim() ||
            modalPayload.length > 0) {
            dataObject.campaigns.PUT(updatePayload);
            return 
		}
        //if (Object.keys(updatePayload).length > 0  ) {
        //    console.log(data?.name.trim() === updatePayload.name.trim())
        //    dataObject.campaigns.PUT(updatePayload);
        //}
        //if (modalPayload.length > 0) {
        //    dataObject.campaign.PUT(modalPayload);
        //}
        console.log('Update the Campaign or Cancel the Edit Request')

    }

    const goBackHandler = () => {
        setSharedData((prevState) => ({ ...prevState, isModalActive: false, modalTarget: "" }))
        history.push('/Campaigns')
    }


    return (
        <Grid container justify="center" style={{ minWidth: '80vw' }} >
            {isLogged &&
            <Grid item xs={12} style={{ marginTop: 50, marginBottom: 25 }}>
                <Grid container justify="center">
                    {isEditing ?
                    <Grid item style={{marginRight: 5 }}>
                        <Button onClick={saveHandler} variant="contained" color="primary" size={"large"} startIcon={<SaveAlt />} >Save</Button>
                    </Grid>
                    :
                        <Grid item style={{ marginRight: 5 }}>
                        <Button onClick={goBackHandler} variant="contained" color="primary" size={"large"} startIcon={<ArrowBack />} >Go Back</Button>
                    </Grid>    
                        }
                    <Grid item style={{ marginLeft: 5 }}>
                        <Button onClick={() => {
                            if (isEditing) {
                                setUpdatePayload({ name: "", description: "" })
                                setSharedData((prevState) => ({...prevState,modalPayload:[]}))
                            };
                            setIsEditing(!isEditing);
                        }} variant="contained" color="secondary" size={"large"} startIcon={!isEditing ? <EditIcon /> : <ClearIcon /> } >{isEditing ? "Cancel" : "Edit"}</Button>
                    </Grid>
                </Grid>
            </Grid>}
            <Grid item xs={12} style={{ marginBottom: 25}}>
                {!isEditing ?
                    <Typography variant="h2" align="center" component="h2">
                        {data?.name}
                    </Typography>
                    :
                    <TextField
                        label="Title"
                        fullWidth
                        onChange={(evt) => {
                            setUpdatePayload((prevState) => ({ ...prevState, name: evt.target.value }))
                        }}
                        defaultValue={data?.name}
                        variant="outlined"
                    />
                }
            </Grid>
            <Grid item xs={12} style={{ marginBottom: 50 }}>
                <Typography variant="h4" align="center" component="h4">
                    Campaign started on {data?.createdDate}
                </Typography>
            </Grid>
            <Grid item xs={10} style={{ marginBottom: 50 }}>
                {!isEditing ?
                    <Typography variant="body1" align="center" component="span" >
                        {data?.description}
                    </Typography>
                    :
                    <TextField
                        label="description"
                        multiline
                        fullWidth
                        onChange={(evt) => {
                            setUpdatePayload((prevState) => ({ ...prevState, description: evt.target.value }))
                        }}
                        defaultValue={data?.description}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        margin="normal"
                    />
                }
            </Grid>
            <Grid item xs={10} style={{ marginBottom: 50 }}>
                <Table stopPropagation={isEditing}  dataObject={dataObject} createContent={isEditing} deletableContent={isEditing} rows={data?.missions ? data.missions : []} columns={columns} action={actionHandler} />
            </Grid>
        </Grid>
	)
}
export default Campaign ;
